<template>
  <MisemegMini />
</template>
<script>
import MisemegMini from '../components/MisemegMini';

export default {
  components: {
    MisemegMini,
  },
};
</script>
